/**
 * Product Variation PropTypes
 *
 * PropType definitions for product variants including colors, sizes, and stock information.
 * Used in product variant selectors and variant management components.
 *
 * @module propTypes/product-variation
 */

import PropTypes from "prop-types";

/**
 * Product size option shape
 * Represents a size variant with stock information
 *
 * @property {string} name - Size name (e.g., "S", "M", "L", "52-18")
 * @property {number} stock - Available stock quantity
 */
export const sizeOptionShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  stock: PropTypes.number.isRequired,
});

/**
 * Product variation shape
 * Represents a complete product variant (color + available sizes)
 *
 * @property {string} color - Color variant name
 * @property {Array} size - Array of size options with stock
 */
export const variationShape = PropTypes.shape({
  color: PropTypes.string.isRequired,
  size: PropTypes.arrayOf(sizeOptionShape).isRequired,
});
